import React, { useEffect, useState } from 'react';

import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import InputRut from '../../../../components/inputs/yup/materialui/inputRut';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';

import Grid2 from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import PeopleTwoToneIcon from '@mui/icons-material/PeopleTwoTone';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';


import EstadosCiviles from "../../../../mocks/estadosCiviles.json";
import Sexos from "../../../../mocks/sexos.json";
import { ciudadesSelect, EliminarParticipante, estadoCivilSelect, Participante } from '../../models/participantes';
import { useParticipantes } from '../../hooks/useParticipantes';
import { Conyuge, ConyugeDto } from '../../models/conyuge';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import validaRut from '../../../../utils/validaRut';
import { useToast } from '../../../../hooks/useToast';
import { actualizarConyuge, guardarConyuge } from '../../services/servicesConyuge';
import { CodigoEnum, enumTipoParticipanteConValores, StatusCode, TipoDireccion, TipoFuncionalidad } from '../../../../utils/enums';
import Validaciones from '../../../../utils/validaciones';
import { format } from 'rut.js';
import { AxiosResponse } from 'axios';
import { useDetalleMutuoPermissions } from '../../hooks/useDetalleMutuoPermissions';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';


interface IProps {
    dataConyuge: Conyuge | undefined;
    ciudadesSelect: ciudadesSelect[];
    estadoCivilSelect: estadoCivilSelect[];
    idMutuo: number;
    setShowParticipantes: React.Dispatch<React.SetStateAction<boolean>>;
    renderizar: () => void;
    volver: () => void;
    esNuevo: boolean;
    esMutuoNormalyConComplementario: boolean;
    participantes: Participante[],
    handleDelete: (dataDelete: EliminarParticipante) => void
    isComplementario: boolean
    isDesactivado?: boolean;
    esVigente?: boolean;
}

const ConyugeForm: React.FC<IProps> = ({ participantes, idMutuo, ...props }) => {
    const { comunaPorId, comunasSelect, comunasCorrespondecia, setComunasSelect, setComunasCorrespondecia, } = useParticipantes();

    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const [esNuevo, setEsNuevo] = useState<boolean>(props.esNuevo);
    const { permisoCarteraInfo } = useDetalleMutuoPermissions(props.esVigente);

    const { addToast } = useToast();

    const schemaConyuge = Yup.object<Conyuge>().shape({
        rut: Yup.string()
            .default('')
            .nonNullable()
            .test('valida-rut', 'RUT inválido', function (value) {
                return validaRut.rutFormat(value);
            })
            .required('El RUT es obligatorio')
            .test({
                name: 'valida-rut-distinto-deudor',
                exclusive: false,
                params: {},
                message: 'RUT debe ser distinto al del resto de los participantes',
                test: async (value, { createError }) => {

                    let rutIngresado: string = format(value, { dots: false });

                    let deudor: Participante | undefined = participantes?.find(x => x.idTipoParticipante ===
                        enumTipoParticipanteConValores.Deudor);
                    if (deudor && rutIngresado === deudor.rut) {
                        return createError({ message: "RUT no permitido, pertenece al deudor del mutuo" });
                    }

                    let rutPermitido: boolean = true;
                    participantes?.forEach((participante: Participante) => {

                        if (participante.idTipoParticipante === enumTipoParticipanteConValores.Mandatario) {
                            if (participante.rut === rutIngresado) {
                                rutPermitido = false;
                            }
                        }

                    });

                    if (participantes.some(x => x.idTipoParticipante === enumTipoParticipanteConValores.Codeudor && x.rut === rutIngresado))
                        return createError({ message: "RUT no permitido, pertenece a un codeudor. Si quieres agregar un codeudor tipo cónyuge, se debe realizar desde el formulario del codeudor." });


                    if (!rutPermitido)
                        return createError({ message: "RUT no permitido, pertenece a un mandatario" })

                    return true;
                }
            }),

        apellidopaterno: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-apellido.paterno', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        apellidomaterno: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-apellido.materno', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        nombres: Yup.string().required('Campo requerido').max(50, 'Máximo 50 caracteres').test('valida-nombres', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        fechanacimiento: Yup.date().required('Campo requerido').test('mayor-edad', 'El cónyuge debe ser mayor de edad', function (value) {
            return Validaciones.esMayor18Anios(value ?? null)
        }),

        profesion: Yup.string().nullable().max(50, 'Máximo 50 caracteres').test('valida-profesion', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        sexo: Yup.string().required('Campo requerido'),
        estadocivil: Yup.string().required('Campo requerido')
            .test({
                name: 'valida-rut-distinto-deudor',
                exclusive: false,
                params: {},
                message: 'El estado civil del cónyuge y deudor deben ser iguales',
                test: async (value, { createError }) => {

                    let deudor: Participante | undefined = participantes?.find(x => x.idTipoParticipante ===
                        enumTipoParticipanteConValores.Deudor);

                    if (deudor && value !== deudor.estadoCivil) {
                        return createError({ message: "El estado civil del cónyuge y deudor deben ser iguales" });
                    }

                    return true;

                }
            }),

        nacionalidad: Yup.string().nullable().max(30, 'Máximo 30 caracteres').test('valida-nacionalidad', 'Ingresar sólo letras', function (value) {
            return Validaciones.soloLetras(value ?? '')
        }),

        direccion: Yup.string().required('Campo requerido').max(100, 'Máximo 100 caracteres').test('valida-direccion', 'Caractéres inválidos', function (value) {
            return Validaciones.isDireccion(value ?? '')
        }),

        ciudadId: Yup.string().required('Campo requerido'),
        comunaId: Yup.string().required('Campo requerido'),

        direccionCorrespondencia: Yup.string().required('Campo requerido').max(100, 'Máximo 100 caracteres').test('valida-direccionCorresp', 'Caractéres inválidos', function (value) {
            return Validaciones.isDireccion(value ?? '')
        }),

        ciudadCorrespondenciaId: Yup.string().required('Campo requerido'),
        comunaCorrespondenciaId: Yup.string().required('Campo requerido'),

        telefonoparticular: Yup.string().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .notRequired()
            .max(999999999, "Máximo 9 digitos"),
        telefonocelular: Yup.string().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .notRequired()
            .max(999999999, "Máximo 9 digitos"),
        telefonooficina: Yup.string().nullable().transform((value) => Number.isNaN(value) ? null : value)
            .notRequired()
            .max(999999999, "Máximo 9 digitos"),
        email: Yup.string().nullable().test('valida-email', 'Email inválido', function (value) {
            return Validaciones.esValidoEmail(value ?? '');
        }),
    });

    const {
        formState: { errors, isDirty, isValid },
        handleSubmit,
        control,
        setValue,
        watch,
        reset,
        trigger
    } = useForm<Conyuge>({
        defaultValues: props.dataConyuge,
        mode: "onChange",
        resolver: yupResolver(schemaConyuge)
    })

    useEffect(() => {
        if (props.dataConyuge?.ciudadId)
            comunaPorId(props.dataConyuge?.ciudadId);

        if (props.dataConyuge?.ciudadCorrespondenciaId)
            comunaPorId(props.dataConyuge?.ciudadCorrespondenciaId, true);

        reset(props.dataConyuge);
    }, [props.dataConyuge, reset])

    const handleCiudadComuna = async (id: string | null, esCorrespondencia: boolean) => {

        if (esCorrespondencia) {
            setValue('comunaCorrespondenciaId', '');
            setComunasCorrespondecia([]);
        } else {
            setValue('comunaId', '');
            setComunasSelect([]);
        }

        trigger("comunaId");
        trigger("comunaCorrespondenciaId");

        if (id) {
            await comunaPorId(id, esCorrespondencia);
        }
    }

    const handleCancelarEdicionClick = () => {
        if (esNuevo) {
            handleCancelarAgregarClick();
            return;
        }

        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: "¿Desea abandonar la edición?",
                metodo: () => {
                    setIsEditing(false);
                    reset();
                },
            });
        }
        else {
            setIsEditing(false);
            reset();
        }
    }

    const handleCancelarAgregarClick = () => {
        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: "¿Desea abandonar el ingreso?",
                metodo: () => {
                    props.setShowParticipantes(true);
                    setIsEditing(false);
                    props.volver();
                    reset();
                },
            });
        }
        else {
            props.setShowParticipantes(true);
            setIsEditing(false);
            props.volver();
            reset();
        }
    }

    async function onSubmit(data: ConyugeDto) {
        data.tipoPart = TipoDireccion.PARTICULAR_CONYUGE;
        data.tipoCorresp = TipoDireccion.CORRESPONDENCIA_CONYUGE;
        data.codeudor = CodigoEnum.NO_ES_CODEUDOR;
        data.rut = format(data.rut, { dots: false });
        data.mutuoId = idMutuo;

        try {
            const response: AxiosResponse = esNuevo ? await guardarConyuge(data) : await actualizarConyuge(data);

            if (response.status === StatusCode.Ok || response.status === StatusCode.Created || response.status === StatusCode.NoContent) {
                addToast({
                    mostrar: true,
                    titulo: 'Confirmación',
                    tipo: 'Success',
                    mensaje: esNuevo
                        ? 'Datos creados correctamente'
                        : 'Datos modificados correctamente'
                });

                setEsNuevo(false);
                setIsEditing(false);
                reset(watch());
                props.renderizar();
            }

        } catch (error) {
            console.error('Error ' + error);
        }

    }

    useEffect(() => {
        if (esNuevo) {
            setIsEditing(true);
            trigger();
        } else {
            setIsEditing(false);
        }

    }, [esNuevo])

    const eliminarConyuge = async () => {
        const data: EliminarParticipante = {
            idTipoParticipante: enumTipoParticipanteConValores.Conyuge,
            rut: watch().rut ?? props.dataConyuge?.rut,
            nombre: `${watch().nombres} ${watch().apellidopaterno} ${watch().apellidomaterno}`
        }
        props.handleDelete(data);
    }

    const isReadonlyWithPermission = () => {
        // Si NO es vigente (Bandeja), NO valida permisos
        if (!props.esVigente) return !isEditing && !esNuevo;
        // Si ES vigente (Cartera), valida permiso
        return !isEditing || !permisoCarteraInfo;
    }
    console.log('de0',permisoCarteraInfo)
    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <form onSubmit={handleSubmit(onSubmit)}>

                {!isEditing ?

                    <Grid2 container spacing={2} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <Typography variant="h4">Cónyuge</Typography>
                        </Grid2>
                        <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                            {!props.isComplementario && (
                                <>
                                    <DetalleMutuoPermissionGuard
                                        esVigente={props.esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar]}>

                                        <MButton variant="contained" color="error" disabled={props.isDesactivado} onClick={() => { eliminarConyuge(); }} startIcon={<DeleteTwoToneIcon />}>
                                            Eliminar
                                        </MButton>
                                    </DetalleMutuoPermissionGuard>
                                    <DetalleMutuoPermissionGuard
                                        esVigente={props.esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info, TipoFuncionalidad.Cartera_editar_contacto]}>

                                        <MButton variant="contained" color="primary" disabled={props.isDesactivado} onClick={() => { setIsEditing(true); trigger(); }} startIcon={<EditTwoToneIcon />}>
                                            Editar
                                        </MButton>
                                    </DetalleMutuoPermissionGuard>
                                </>
                            )}
                            <MButton variant="contained" color="primary" onClick={() => { props.setShowParticipantes(true); setIsEditing(false); props.volver(); }} startIcon={<PeopleTwoToneIcon />}>
                                Listado participantes
                            </MButton>
                        </Grid2>
                    </Grid2>
                    :
                    <Grid2 container spacing={2} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 2 }}>
                            <Typography variant="h4">Cónyuge</Typography>
                        </Grid2>
                        <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                            <MButton
                                variant='contained'
                                color="primary"
                                disabled={!(isDirty && isValid)}
                                onClick={handleSubmit(onSubmit)}
                                startIcon={<SaveOutlinedIcon />}
                            >
                                Guardar
                            </MButton>
                            <MButton
                                type="button"
                                variant='contained'
                                color="inherit"
                                onClick={() => { handleCancelarEdicionClick(); }}
                                startIcon={<CloseOutlinedIcon />}>
                                Cancelar
                            </MButton>
                        </Grid2>
                    </Grid2>
                }

                <Grid2 sx={{ mt: 2, mb: 3 }}>
                    <Card raised >
                        <CardContent>

                            <Typography className='card-title' variant="h6" gutterBottom>
                                Datos Personales
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputRut
                                        label="RUT"
                                        name="rut"
                                        control={control}
                                        error={errors.rut}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Apellido paterno"
                                        name="apellidopaterno"
                                        control={control}
                                        error={errors.apellidopaterno}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Apellido materno"
                                        name="apellidomaterno"
                                        control={control}
                                        error={errors.apellidomaterno}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Nombres"
                                        name="nombres"
                                        control={control}
                                        error={errors.nombres}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputFecha
                                        label="Fecha nacimiento"
                                        name="fechanacimiento"
                                        control={control}
                                        fecha={watch().fechanacimiento ?? undefined}
                                        error={errors.fechanacimiento}
                                        esReadOnly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Profesión o actividad"
                                        name="profesion"
                                        control={control}
                                        error={errors.profesion}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Sexo"
                                        name={'sexo'}
                                        control={control}
                                        options={Sexos}
                                        error={errors.sexo}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Estado civil y régimen matrimonial"
                                        name={'estadocivil'}
                                        control={control}
                                        options={EstadosCiviles}
                                        error={errors.estadocivil}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Nacionalidad"
                                        name={'nacionalidad'}
                                        control={control}
                                        error={errors.nacionalidad}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

                <Grid2 sx={{ mt: 2, mb: 3 }}>
                    <Card raised >
                        <CardContent>
                            <Typography className='card-title' variant="h6" gutterBottom>
                                Contacto
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono particular"
                                        name="telefonoparticular"
                                        control={control}
                                        readonly={isReadonlyWithPermission()}
                                        minValue={0}
                                        maxValue={999999999}
                                        error={errors.telefonoparticular}
                                        prefix='+56'
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono celular"
                                        name="telefonocelular"
                                        control={control}
                                        readonly={isReadonlyWithPermission()}
                                        minValue={0}
                                        maxValue={999999999}
                                        error={errors.telefonocelular}
                                        prefix='+56'
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputNumber
                                        label="Teléfono oficina"
                                        name="telefonooficina"
                                        control={control}
                                        readonly={isReadonlyWithPermission()}
                                        maxValue={999999999}
                                        minValue={0}
                                        error={errors.telefonooficina}
                                        prefix='+56'
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Email"
                                        name="email"
                                        control={control}
                                        error={errors.email}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>

                <Grid2 sx={{ mt: 2, mb: 3 }}>
                    <Card raised >
                        <CardContent>
                            <Typography className='card-title' variant="h6" gutterBottom>
                                Dirección particular
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputText
                                        label='Dirección'
                                        name="direccion"
                                        control={control}
                                        error={errors.direccion}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label='Ciudad'
                                        name={'ciudadId'}
                                        control={control}
                                        options={props.ciudadesSelect}
                                        error={errors.ciudadId}
                                        onChange={(value) => handleCiudadComuna(value ?? '', false)}
                                        disabled={isReadonlyWithPermission()}
                                    ></InputSelect>
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label='Comuna'
                                        name={'comunaId'}
                                        control={control}
                                        options={comunasSelect}
                                        error={errors.comunaId}
                                        disabled={isReadonlyWithPermission()}
                                    ></InputSelect>
                                </Grid2>
                            </Grid2>

                            <Typography className='card-title' variant="h6" gutterBottom>
                                Dirección envío correspondencia
                            </Typography>

                            <Grid2 container spacing={2} sx={{ mt: 2 }}>
                                <Grid2 size={3}>
                                    <InputText
                                        label="Dirección"
                                        name="direccionCorrespondencia"
                                        control={control}
                                        error={errors.direccionCorrespondencia}
                                        readonly={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Ciudad"
                                        name="ciudadCorrespondenciaId"
                                        control={control}
                                        options={props.ciudadesSelect}
                                        error={errors.ciudadCorrespondenciaId}
                                        onChange={(value) => handleCiudadComuna(value, true)}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                                <Grid2 size={3}>
                                    <InputSelect
                                        label="Comuna"
                                        name="comunaCorrespondenciaId"
                                        control={control}
                                        options={comunasCorrespondecia}
                                        error={errors.comunaCorrespondenciaId}
                                        disabled={isReadonlyWithPermission()}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>
            </form>
        </>
    );
};

export default ConyugeForm;